"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotInfo = void 0;
var BotInfo;
(function (BotInfo) {
    BotInfo[BotInfo["SILENT"] = 0] = "SILENT";
    BotInfo[BotInfo["END_STATS"] = 1] = "END_STATS";
    BotInfo[BotInfo["WARN"] = 2] = "WARN";
    BotInfo[BotInfo["VERBOSE"] = 3] = "VERBOSE";
})(BotInfo || (exports.BotInfo = BotInfo = {}));
//# sourceMappingURL=BotInfo.js.map